module.exports = __webpack_public_path__ + "static/media/VP-konto-2.23a079af.png";